import React, { Fragment } from 'react'
import { Container, Col, Row, Button, Card, CardBody, Input } from 'reactstrap';
import { useStainGrams } from '../../../hooks/micro/useStainGrams';
import { ModalStainGrams } from '../../../components/micro/stainGrams/ModalStainGrams';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexStainGrams = () => {

    const {
     // * LIST
     listStainGrams,
     //* CRUD TABLE
     handleCreate,handleUpdate,handleDelete,toggle,method,modal,tittle,
     name,handleInputChange,titleDelete,
     saveCreate,saveUpdateStain,saveDeleteStain,loading,
    handleExportExcelStainGrams,

    //* SEARCH
    handleSearchStainGrams, handleClearStainGrams, searchStainGrams, loadingExport, 

    //*DIALOG
    closeDeleteAlert, closeDialogG,
    showDeleteAlert, modalAlert, 

    } = useStainGrams();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
    
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_mic_stain_gram)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_mic_stain_gram)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };
    

    return (
        <Fragment>
            <div className="container-global-zoom">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                    <TitleDataTable
                                        titleTable="Listado de Tinción de Gram"
                                        buttonActions={handleExportExcelStainGrams}
                                        titleButton="Tinción de Gram"
                                        isDisbled={loadingExport}
                                        loadingIsDisabled={loadingExport}
                                        titleCreate="Crear Laboratorio"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearchStainGrams}
                                        valueFilter={searchStainGrams}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearStainGrams}

                                    />
                                </Col>
     
                                <div className="table-responsive">
                                    <DataTable value={listStainGrams} paginator rows={10} responsiveLayout="scroll" rowsPerPageOptions={[10, 50, 100]}  className="data-table p-datatable-striped p-datatable-sm" emptyMessage={
                                        <div className="text-center">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                style={{ width: "32%" }}
                                                alt="Sin resultados"
                                            />
                                            <br />
                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                No se encontraron resultados.
                                            </p>
                                        </div>}
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="name" header="Grams" headerStyle={headerStyle} style={cellStyle} />
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                            </CardBody>
                        </Card>

                        {showDeleteAlert && (
                            <AlertDataTable
                                titleAlert="Eliminar Gram"
                                visibleAlert={modalAlert}
                                onHideAlert={closeDeleteAlert}
                                sizeAlert="medium-dialog delete-method"
                                messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el Gram?"
                                alert1={true}
                                titleAlert1={name}
                                buttonAcept
                                titleNotLoading="Eliminar"
                                titleDanger="Cancelar"
                                actionAcept={saveDeleteStain}
                            />

                        )}
                        <ModalStainGrams
                            {...{
                                modal, closeDialogG, toggle, method,
                                name,
                                handleInputChange, loading,titleDelete,
                                saveCreate,saveUpdateStain,saveDeleteStain, tittle
                            }}
                        />
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}
